
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000","fill":"#989AB3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M990 983.7H533.9V420.4H990v563.3zm-393.2-63.4H927V483.8H596.8v436.5zm-130.7 63.4H10V749.5h456.1v234.2zM72.9 920.3h330.3V813H72.9v107.3zM990 385.1H10V16.3h980v368.8zM72.9 321.6h854.2V79.7H72.9v241.9zm393.2 377.1H10V420.4h456.1v278.3zM72.9 635.3h330.3V483.8H72.9v151.5z"}})])
          )
        }
      }
    